import { useEffect, useState } from "react";
import Board from '../models/board';
import "react-toggle/style.css"; // Import toggle styles
import Toggle from "react-toggle";
import Icon from '../atoms/Icon';
import BoardForm from "../forms/BoardForm";
import { FormReveal } from "./Animations";
import { makeBEM } from "../global/utils";
import { UTILITY_CSS_CLASSES } from "../global/constants";

export function BoardSetting(props) {

    const [board, setBoard] = useState(null); 
    const [editMode, setEditMode] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [boardTypes, setBoardTypes] = useState([]);
    const [controller, setController] = useState([]);

    const moduleName = 'board-setting';

    useEffect(() => {
        if ( props.data ) {
            createBoardFromData(props.data);
        }

        if ( props.boardTypes ) {
            setBoardTypes(props.boardTypes);
        }

        if ( props.controller ) {
            setController(props.controller);
        }
    }, [props])

    const createBoardFromData = (data) => {
        const board = new Board();
        if ( data && data.id ) {
            board.initFromData(data);

            setBoard(board);
            setHidden(board.getHidden());
        }        
    }

    const handleSwitch = (e) => {
        const hidden = !e.target.checked
        board.toggleVisibility(e.target.checked);

        setBoard(board);
        setHidden(hidden);

        controller.toggleBoardVisibility(hidden, board.id, board.type);
    }

    const toggleEditMode = () => {
        setEditMode(!editMode);
    }

    const setItemFromResult = (result) => {
        if ( result.board ) {
            createBoardFromData(result.board);
        }
    }
    
    const editSuccess = (result) => {
        setItemFromResult(result);
        controller.editBoardSuccess(result.board);
    }

    const modifierClass = props.parentEditMode ? `${moduleName}--${UTILITY_CSS_CLASSES.editing}` : '';
    const mainClass = `${moduleName} ${modifierClass}`;
    const sortBtnClass = `btn btn--icon btn--no-border btn--sort sortable__btn ${ makeBEM(moduleName, 'sort-btn') }`

    return (
        !board ? false :
        <div className={ mainClass }>
            <div className={ makeBEM(moduleName, 'wrapper') } onDoubleClick={ toggleEditMode }>
                <span className="title">{board.getTitle()}</span>
                {
                    !props.parentEditMode ?
                    <Toggle
                        className={ `toggle-switch ${makeBEM(moduleName, 'visibility-switch')}` } 
                        checked={!hidden}
                        onChange={ handleSwitch }
                        icons={false}
                    /> 
                    :
                    <button 
                        className={ sortBtnClass } 
                        {...props.sortData.attributes} {...props.sortData.listeners}>
                        <Icon name="move" size={4} type="fill"/>
                    </button>
                }
            </div>
            {
                editMode && !props.parentEditMode &&
                <FormReveal>
                    <BoardForm 
                        board={board.toFormObject()}
                        boardTypes={boardTypes}
                        discardForm={toggleEditMode}
                        editSuccess={editSuccess}
                        deleteSuccess={props.deleteAction ? props.deleteAction : false}
                    />
                </FormReveal>
            }
        </div>
    )
}